import { alignHeight } from "scripts/services/master_book/cover_editor/font-size";

function resizableTextareaHandler(e) {
  const {
    currentTarget
  } = e;

  if (currentTarget.scrollHeight < 375) {
    alignHeight(currentTarget);
  }
}

export default resizableTextareaHandler;